import {FieldError} from "@client/components/FieldError";
import {widgetStyles} from "@client/forms/widgets";
import {classNames} from "@reactivated";
import * as React from "react";

interface Props {
    error: string | null;
    label: React.ReactNode | null;
    children?: React.ReactNode;
}

/**
 * We don't use a <label> tag because you cannot have multiple inputs inside of
 * one. Unfortunate but that's life. Better accessibility can come later.
 */
export const Label = ({children, label, error}: Props) => (
    <div
        className={classNames(widgetStyles.label, error != null && widgetStyles.error)}
    >
        {label != null && <div className={widgetStyles.labelText}>{label}</div>}
        <FieldError error={error}>{children}</FieldError>
    </div>
);
